import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { authHeader } from "@/utils/headers";

export const useRequestWorflowCounts = () => {
  const { workspaceId, workflowId } = useParams();
  const auth = useAuth();

  return useQuery(["requsetCountsForWorkflows", workspaceId, workflowId], () =>
    fetch(ENDPOINTS.get_request_counts_for_workflows(Number(workspaceId), Number(workflowId)), {
      headers: authHeader(auth?.userToken ?? ""),
    }).then(handleResponse),
  );
};
